import type { MsrPurchaseOrderPrintOptionsInput } from '~/graphql/graphql';

export type MsrPurchaseOrderPrintOptions =
  Readonly<MsrPurchaseOrderPrintOptionsInput>;

export const ALL_MSR_PRINT_OPTIONS: MsrPurchaseOrderPrintOptions = {
  prices: true,
  shippingInstructions: true,
  weight: true,
  shipTo: true,
};

export function msrPurchaseOrderPdfUrl(
  orderId: string,
  {
    download = false,
    printOptions = ALL_MSR_PRINT_OPTIONS,
  }: { download?: boolean; printOptions?: MsrPurchaseOrderPrintOptions } = {}
): string {
  const url = `/api/orders/${encodeURIComponent(orderId)}/msr-purchase-order.pdf`;
  const params = new URLSearchParams();
  if (download) {
    params.set('download', 'true');
  }
  for (const [name, shown] of Object.entries(printOptions)) {
    if (!shown) {
      params.set(name, 'false');
    }
  }
  const query = params.toString();
  return query ? `${url}?${query}` : url;
}
